const userRoutes = [
    // {
    //     path: '/user',
    //     name: 'User',
    //     component: () => import('../views/User/index.vue')
    // },
    {   // 用户 - 个人资料
        /*******该路由未使用[用户信息都跳转instructor-info]***********/
        path: '/user-info',
        name: 'UserInfo',
        component: () => import('../views/User/Info_user.vue')
    },
    {   // 教练 - 个人资料
        path: '/instructor-info',
        name: 'InstructorInfo',
        component: () => import('../views/User/Info_instructor.vue')
    },
    {
        // 教练 个人简介页
        path: '/user-produce',
        name: 'UserProduce',
        component: () => import("../views/User/Produce.vue")
    },

    {   // 兑奖中心
        path: '/exchange-center',
        name: 'ExchangeCenter',
        component: () => import('../views/User/Exchange.vue')
    },
    {   // 我的奖品
        path: '/my-gift',
        name: 'MyGift',
        component: () => import('../views/User/MyGift.vue')
    },

    {   // 分销中心
        path: '/sale-center',
        name: 'SaleCenter',
        component: () => import('../views/User/SaleCenter.vue')
    },
    {   // 分销订单
        path: '/sale-order',
        name: 'SaleOrder',
        component: () => import('../views/User/SaleOrder.vue')
    },
    {   // 提现
        path: '/tixian',
        name: 'Tixian',
        component: () => import('../views/User/Tixian.vue')
    },
    {   // 提现记录
        path: '/tixian-record',
        name: 'TixianRecord',
        component: () => import('../views/User/Tixian_record.vue')
    },
    {   // 收益明细
        path: '/sale-detail',
        name: 'SaleDetail',
        component: () => import('../views/User/SaleDetail.vue')
    },
    {   // 订单列表
        path: '/MyOrder',
        name: 'MyOrder',
        component: () => import('../views/User/MyOrder.vue')
    },
    {   // 我的卡券
        path: '/MyVoucher',
        name: 'MyVoucher',
        component: () => import('../views/User/MyVoucher.vue')
    },
    {   // 我的收藏
        path: '/MyCollection',
        name: 'MyCollection',
        component: () => import('../views/User/MyCollection.vue')
    },
    {   // 收款码
        path: '/CollectionCode',
        name: 'CollectionCode',
        component: () => import('../views/User/CollectionCode.vue')
    },
    {   // 我的会员码
        path: '/MaintainVipCode',
        name: 'MaintainVipCode',
        component: () => import('../views/User/MaintainVipCode.vue')
    }
]

export default userRoutes;